/**
 * Wacht tot een conditie true teruggeeft, met retries.
 * @param {Function} conditionFn - moet true returnen als klaar
 * @param {Function} callback - wordt uitgevoerd als klaar
 * @param {Object} options
 * @param {number} options.intervalMs - wachttijd tussen checks
 * @param {number} options.timeoutMs - max totale wachttijd
 */
export function retryUntilAvailable(
  conditionFn,
  callback,
  { intervalMs = 300, timeoutMs = 10000 } = {}
) {
  const start = Date.now();

  const interval = setInterval(() => {
    if (conditionFn()) {
      clearInterval(interval);
      callback();
    } else if (Date.now() - start >= timeoutMs) {
      clearInterval(interval);
      console.warn("[retryUntilAvailable] Timeout reached.");
    }
  }, intervalMs);
}

export function trackPageImpression({
  boxname = "tools",
  pageid = "default",
  lang = "nl-BE",
}) {
  retryUntilAvailable(
    () =>
      typeof window !== "undefined" &&
      window.digitalData &&
      Array.isArray(window.digitalData.events),
    () => {
      const dnow = Date.now();
      const currentUrl = new URL(window.location.href);
      const param_lang = lang.substring(0, 2);
      const boxUrl = `/EDUbox/games/${boxname}/`;
      const trackUrl = `${boxUrl}${pageid}`;
      const eduboxTitle = `EDUbox Games - ${boxname} - ${pageid}`;
      const baseUrl = `https://${currentUrl.hostname}`;
      const pageUrl = `${baseUrl}${trackUrl}`;

      window.digitalData.events.push({
        event: {
          schema: "iglu:be.vrt/page_impression/jsonschema/1-1-0",
          data: {
            timestamp: dnow,
          },
        },
        context: [
          {
            schema: "iglu:be.vrt/context_page/jsonschema/1-2-1",
            data: {
              pagename: trackUrl,
              touchpointbrand: "vrt",
              contentbrand: "edubox",
              pageurl: pageUrl,
              pagetitle: eduboxTitle,
              domain: "www.vrt.be",
              pagepath: trackUrl,
              pagelanguage: param_lang,
              sitesection1: "",
              sitesection2: "",
              sitesection3: eduboxTitle,
              sitesection4: "",
              pageid: `vrtedubox${trackUrl}`,
            },
          },
        ],
      });

      // console.info("[Analytics] Pushed page impression:", trackUrl);
    }
  );
}
